import React from "react";
import styles from "./Variants.module.scss";
import { DropDown } from "../../../../../../../shared/DropDown/DropDown";
import { VariantItem } from "./VariantItem/VariantItem";
import { useAppSelector } from "../../../../../../../redux/store";
import {
  getCurrentCategoryFolder,
  getProjectByIdAndPath,
  getProductsFromCacheByProject,
} from "../../../../../../../redux/reducers/ui/selectors/objectSelectors";

interface PropsI {
  projectId: number;
  path: number[];
}
export const Variants: React.FC<PropsI> = ({ projectId, path }) => {
  const currentCategoryFolder = useAppSelector(getCurrentCategoryFolder);
  const projectFromPath = useAppSelector(
    getProjectByIdAndPath(projectId, path)
  );
  const productsFromCache = useAppSelector(
    getProductsFromCacheByProject(projectId)
  );

  // First try to get project from currentCategoryFolder (has fetched products)
  const projectFromFolder = currentCategoryFolder?.projects?.find(
    p => p.id === projectId
  );

  // Prefer project from currentCategoryFolder, then path-based lookup
  const project = projectFromFolder || projectFromPath;

  // Determine available products: from project if present, else from cache
  const availableProducts = project?.availableProducts || productsFromCache;

  if (
    !availableProducts ||
    availableProducts.length < 2 ||
    availableProducts.filter(project => project.studio).length < 1
  )
    return null;
  return (
    <DropDown title={"Variants"} defaultOpen={true}>
      <div className={styles.list}>
        {availableProducts
          .filter(project => project.studio)
          .map(p => (
            <VariantItem
              key={`${p.id}-${p.name}`}
              productId={p.id}
              projectId={projectId}
              path={path}
            />
          ))}
      </div>
    </DropDown>
  );
};
